var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSmallGroup(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 45,
    height: 44,
    viewBox: "0 0 45 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.5853 9.25928C19.3569 8.81451 20.3217 8.84599 21.0658 9.354L30.3998 15.729L30.516 15.814C31.0822 16.2542 31.4163 16.9332 31.4164 17.6558V32.0669C31.4162 32.7663 30.8492 33.3335 30.1498 33.3335H23.2172C22.5177 33.3335 21.9498 32.7663 21.9496 32.0669V26.8901H17.5502V32.0669C17.55 32.7662 16.9829 33.3334 16.2836 33.3335H9.34998C8.65058 33.3335 8.08358 32.7663 8.08337 32.0669V17.6558C8.08351 16.8851 8.46452 16.1637 9.10095 15.729L18.434 9.354L18.5853 9.25928Z",
    fill: "#ACB1BB",
    stroke: "white",
    strokeWidth: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M25.5853 11.2593C26.3569 10.8145 27.3217 10.846 28.0658 11.354L37.3998 17.729L37.516 17.814C38.0822 18.2542 38.4163 18.9332 38.4164 19.6558V34.0669C38.4162 34.7663 37.8492 35.3335 37.1498 35.3335H30.2172C29.5177 35.3335 28.9498 34.7663 28.9496 34.0669V28.8901H24.5502V34.0669C24.55 34.7662 23.9829 35.3334 23.2836 35.3335H16.35C15.6506 35.3335 15.0836 34.7663 15.0834 34.0669V19.6558C15.0835 18.8851 15.4645 18.1637 16.101 17.729L25.434 11.354L25.5853 11.2593Z",
    fill: "#ACB1BB",
    stroke: "white",
    strokeWidth: 2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSmallGroup);
export default __webpack_public_path__ + "static/media/small-group.267ad8cf905f4468372308744b6807ee.svg";
export { ForwardRef as ReactComponent };